import React from "react";
import { Link } from "react-router-dom";
import SegmentedControl from "./SegmentedControl";
import { images } from "../data/images";

export default function Header() {
  return (
    <header>
      <Link to="/work" style={{ textDecoration: "none" }}>
      <div className="header-left">
        <img 
          src={images.profile[0]?.src || ''}
          alt="Abby" 
          className="profile-photo"
        />
        <div className="header-text">
          <h1>Abby Jetmundsen</h1>
          <h2>Product Designer</h2>
        </div>
      </div>
      </Link>
      <SegmentedControl />
    </header>
  );
}
